class UserActions {
  /*===========
    LOGIN
    =============*/
  static LOGIN = "LOGIN";
  static LOGIN_SUCCESS = "LOGIN_SUCCESS";
  static LOGIN_FAILURE = "LOGIN_FAILURE";
  static login() {
    return {
      type: this.LOGIN,
    };
  }
  static loginSuccess(user, token) {
    return {
      type: this.LOGIN_SUCCESS,
      payload: { user, token },
    };
  }
  static loginFailure(errorMessage) {
    return {
      type: this.LOGIN_FAILURE,
      payload: { errorMessage },
    };
  }

  /*===========
    SINGUP
    =============*/
  static SIGNUP = "SIGNUP";
  static SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
  static SIGNUP_FAILURE = "SIGNUP_FAILURE";
  static signup() {
    return {
      type: this.SIGNUP,
    };
  }
  static signupSuccess(user, token) {
    return {
      type: this.SIGNUP_SUCCESS,
      payload: { user, token },
    };
  }
  static signupFailure(errorMessage) {
    return {
      type: this.SIGNUP_FAILURE,
      payload: { errorMessage },
    };
  }

  /*===========
    LOGOUT
    =============*/
  static LOGOUT = "LOGOUT";
  static LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
  static LOGOUT_FAILURE = "LOGOUT_FAILURE";
  static logout() {
    localStorage.removeItem("xml-podcast-auth-token");
    return {
      type: this.LOGOUT,
    };
  }
  static logoutSuccess() {
    return {
      type: this.LOGOUT_SUCCESS,
    };
  }
  static logoutFailure(errorMessage) {
    return {
      type: this.LOGOUT_FAILURE,
      payload: { errorMessage },
    };
  }

  /*===========
    INITIAL_LOGIN
    =============*/
  static INITIAL_LOGIN = "INITIAL_LOGIN";
  static INITIAL_LOGIN_SUCCESS = "INITIAL_LOGIN_SUCCESS";
  static INITIAL_LOGIN_FAILURE = "INITIAL_LOGIN_FAILURE";
  static INITIAL_LOGIN_NO_TOKEN = "INITIAL_LOGIN_NO_TOKEN";

  static initialLogin() {
    return {
      type: this.INITIAL_LOGIN,
    };
  }
  static initialLoginSuccess(user, token) {
    return {
      type: this.INITIAL_LOGIN_SUCCESS,
      payload: { user, token },
    };
  }
  static initialLoginFailure(errorMessage) {
    return {
      type: this.INITIAL_LOGIN_FAILURE,
      payload: { errorMessage },
    };
  }
  static initialLoginNoToken = () => {
    return {
      type: this.INITIAL_LOGIN_NO_TOKEN,
    };
  };

  /*===========
    UPDATE_PROFILE
    =============*/
  static UPDATE_PROFILE = "UPDATE_PROFILE";
  static UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
  static UPDATE_PROFILE_FAILURE = "UPDATE_PROFILE_FAILURE";
  static updateProfile() {
    return {
      type: this.UPDATE_PROFILE,
    };
  }
  static updateProfileSuccess(user) {
    return {
      type: this.UPDATE_PROFILE_SUCCESS,
      payload: { user },
    };
  }
  static updateProfileFailure(errorMessage) {
    return {
      type: this.UPDATE_PROFILE_FAILURE,
      payload: { errorMessage },
    };
  }

  /*===========
    UPDATE_PASSWORD
    =============*/
  static UPDATE_PASSWORD = "UPDATE_PASSWORD";
  static UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
  static UPDATE_PASSWORD_FAILURE = "UPDATE_PASSWORD_FAILURE";
  static updatePassword() {
    return {
      type: this.UPDATE_PASSWORD,
    };
  }
  static updatePasswordSuccess() {
    return {
      type: this.UPDATE_PASSWORD_SUCCESS,
    };
  }
  static updatePasswordFailure(errorMessage) {
    return {
      type: this.UPDATE_PASSWORD_FAILURE,
      payload: { errorMessage },
    };
  }

  /*===========
    UPLOAD_IMAGE
    =============*/
  static UPLOAD_IMAGE = "UPLOAD_IMAGE";
  static UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
  static UPLOAD_IMAGE_FAILURE = "UPLOAD_IMAGE_FAILURE";
  static uploadImage() {
    return {
      type: this.UPLOAD_IMAGE,
    };
  }
  static uploadImageSuccess(imageURL) {
    return {
      type: this.UPLOAD_IMAGE_SUCCESS,
      payload: { imageURL },
    };
  }
  static uploadImageFailure(errorMessage) {
    return {
      type: this.UPLOAD_IMAGE_FAILURE,
      payload: { errorMessage },
    };
  }

  /*===========
    DELETE_ACCOUNT
    =============*/
  static DELETE_ACCOUNT = "DELETE_ACCOUNT";
  static DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
  static DELETE_ACCOUNT_FAILURE = "DELETE_ACCOUNT_FAILURE";
  static deleteAccount() {
    return {
      type: this.DELETE_ACCOUNT,
    };
  }
  static deleteAccountSuccess() {
    return {
      type: this.DELETE_ACCOUNT_SUCCESS,
    };
  }
  static deleteAccountFailure(errorMessage) {
    return {
      type: this.DELETE_ACCOUNT_FAILURE,
      payload: { errorMessage },
    };
  }

  /*===========
    REMOVE_IMAGE
    =============*/
  static REMOVE_IMAGE = "REMOVE_IMAGE";
  static REMOVE_IMAGE_SUCCESS = "REMOVE_IMAGE_SUCCESS";
  static REMOVE_IMAGE_FAILURE = "REMOVE_IMAGE_FAILURE";
  static removeImage() {
    return {
      type: this.REMOVE_IMAGE,
    };
  }
  static removeImageSuccess(newImageURL) {
    return {
      type: this.REMOVE_IMAGE_SUCCESS,
      payload: { newImageURL },
    };
  }
  static removeImageFailure(errorMessage) {
    return {
      type: this.REMOVE_IMAGE_FAILURE,
      payload: { errorMessage },
    };
  }
}

export default UserActions;
